import { AlertTriangle, CheckCircle2, Info, X, XCircle } from "lucide-react";
import { useToastContext } from "./ToastContext";

const STYLES = {
  success: {
    icon: CheckCircle2,
    bar: "bg-green-500",
    className:
      "border-green-500/20 bg-green-50 text-green-800 dark:bg-green-500/10 dark:text-green-200",
  },
  error: {
    icon: XCircle,
    bar: "bg-red-500",
    className:
      "border-red-500/20 bg-red-50 text-red-800 dark:bg-red-500/10 dark:text-red-200",
  },
  warning: {
    icon: AlertTriangle,
    bar: "bg-yellow-500",
    className:
      "border-yellow-500/20 bg-yellow-50 text-yellow-800 dark:bg-yellow-500/10 dark:text-yellow-200",
  },
  info: {
    icon: Info,
    bar: "bg-blue-500",
    className:
      "border-blue-500/20 bg-blue-50 text-blue-800 dark:bg-blue-500/10 dark:text-blue-200",
  },
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToastContext();

  return (
    <div
      aria-live="polite"
      aria-atomic="false"
      className="fixed right-4 top-5 z-[9999] flex w-[calc(100%-2rem)] max-w-sm flex-col gap-2.5 sm:right-5 sm:w-full"
    >
      {toasts.map((toast) => {
        const style = STYLES[toast.type] ?? STYLES.info;
        const Icon = style.icon;

        return (
          <div
            key={toast.id}
            role="alert"
            className={`animate-slideIn overflow-hidden rounded-2xl border shadow-xl backdrop-blur-xl ${style.className}`}
          >
            <div className={`h-1 w-full ${style.bar} opacity-70`} />
            <div className="flex items-start gap-3 px-4 py-3">
              <Icon size={18} className="mt-0.5 shrink-0" />
              <p className="flex-1 text-sm font-semibold leading-6">{toast.message}</p>
              <button
                type="button"
                onClick={() => removeToast(toast.id)}
                className="rounded-full p-1 opacity-60 transition hover:bg-black/8 hover:opacity-100 dark:hover:bg-white/10"
                aria-label="Dismiss notification"
              >
                <X size={15} />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
